import type { AlAdvancedAction, AlSimpleDay } from './types';

export const AL_SIMPLE_TIMELINE: AlSimpleDay[] = [
  {
    dayLabel: 'Today',
    date: 'Apr 18, 2026',
    actionCount: 47,
    groups: [
      {
        id: 's-t-1',
        category: 'ads',
        title: 'Optimized bids across 9 campaigns',
        outcome: 'Average cost per click down 8% today',
        detail:
          'Individual adjustments: 31 bid changes · 4 keyword pauses · 2 new keywords added',
        time: 'Throughout the day',
        actionCount: 37,
      },
      {
        id: 's-t-2',
        category: 'landing',
        title: 'Invisalign landing page: Variant A declared winner',
        outcome: 'Now running at 100% of traffic · +22% conversion rate over control',
        detail: 'Test concluded after 2,140 visits across 2 variants in Validation phase',
        time: '2:14 PM',
        actionCount: 1,
      },
      {
        id: 's-t-3',
        category: 'gbp',
        title: 'Responded to 3 new Google reviews',
        outcome: 'Average response time: 42 minutes',
        detail: '1 five-star, 2 four-star reviews · All responses approved and published',
        time: '11:30 AM, 1:45 PM, 3:18 PM',
        actionCount: 3,
      },
      {
        id: 's-t-4',
        category: 'seo',
        title: "Published 1 new article: 'What to Expect After Dental Implant Surgery'",
        outcome: "Targeting 'dental implant recovery' (880 searches/mo)",
        detail: 'Auto-indexed by Google within 4 hours · Schema markup deployed',
        time: '10:05 AM',
        actionCount: 1,
      },
      {
        id: 's-t-5',
        category: 'intel',
        title: 'Detected competitor offering free implant consultations',
        outcome: 'No action needed — your $0 consultation offer is already live',
        detail: 'Downtown Dental launched campaign yesterday · Being monitored',
        time: '9:22 AM',
        actionCount: 1,
      },
      {
        id: 's-t-6',
        category: 'technical',
        title: '4 citation corrections submitted',
        outcome: 'Yelp, Vitals, Zocdoc, MapQuest now match your NAP',
        detail: 'Updates will appear in each directory within 3-14 days',
        time: '6:00 AM',
        actionCount: 4,
      },
    ],
  },
  {
    dayLabel: 'Yesterday',
    date: 'Apr 17, 2026',
    actionCount: 52,
    groups: [
      {
        id: 's-y-1',
        category: 'ads',
        title: "Paused low-performing keyword: 'cheap dentist nyc'",
        outcome: '$48/mo saved · Was generating clicks but 0 bookings',
        detail: 'Paused after 30 days underperformance · 312 clicks, $48 spend, 0 patients',
        time: '4:02 PM',
        actionCount: 1,
      },
      {
        id: 's-y-2',
        category: 'landing',
        title: 'Generated 4 variants for Weekend Emergency landing page',
        outcome: 'Testing starts tomorrow — winner expected in 14 days',
        detail:
          'Variants explore: urgency-led headline, specificity-led, outcome-focused, and control',
        time: '2:30 PM',
        actionCount: 4,
      },
      {
        id: 's-y-3',
        category: 'gbp',
        title: 'Published 2 GBP posts and added 5 office photos',
        outcome: 'Profile completeness increased to 92%',
        detail:
          "Posts: 'Now accepting new patients' and '$99 whitening special' · Photos auto-categorized and captioned",
        time: '11:15 AM',
        actionCount: 7,
      },
      {
        id: 's-y-4',
        category: 'ads',
        title: 'Reallocated budget: +$150 to Implants, −$150 from Veneers',
        outcome: 'Implants ROI 37x, Veneers facing competitor pressure',
        detail: 'Based on last 7 days performance · Reversible if trend shifts',
        time: '10:40 AM',
        actionCount: 2,
      },
      {
        id: 's-y-5',
        category: 'seo',
        title: 'Updated meta descriptions on 6 service pages',
        outcome: 'Recommendations sent to webmaster for deployment',
        detail:
          'Each page now has unique, keyword-optimized meta description · Schema Injector handles the rest',
        time: '9:00 AM',
        actionCount: 6,
      },
    ],
  },
  {
    dayLabel: 'Apr 16, 2026',
    date: 'Wednesday',
    actionCount: 38,
    groups: [
      {
        id: 's-3-1',
        category: 'intel',
        title: 'Quarterly competitor intelligence refresh completed',
        outcome: '8 competitor dossiers updated · 2 new threats identified',
        detail: 'Crawled: websites, GBP listings, review velocity, offer changes, ad positions',
        time: 'Morning',
        actionCount: 8,
      },
      {
        id: 's-3-2',
        category: 'call',
        title: 'Assigned 1 new tracking number for Pediatric campaign',
        outcome: '(212) 555-0151 now routes to AI Receptionist',
        detail: 'From the 10-number pool · 0 currently reserved',
        time: '2:22 PM',
        actionCount: 1,
      },
      {
        id: 's-3-3',
        category: 'landing',
        title: 'Emergency Weekend page moved from Exploration to Validation phase',
        outcome: 'Variant C eliminated (under-performing), top 2 competing',
        detail: 'Phase 1 spent 20% of budget as planned · Phase 2 begins with 50/50 traffic split',
        time: '1:30 PM',
        actionCount: 1,
      },
      {
        id: 's-3-4',
        category: 'technical',
        title: 'Ran website health scan',
        outcome: 'Health score: 78/100 (+3 from last week)',
        detail: 'Detected 8 issues · Webmaster contacted about 3 critical items',
        time: '6:00 AM',
        actionCount: 1,
      },
    ],
  },
];

export const AL_ADVANCED_ACTIONS: AlAdvancedAction[] = [
  { id: 'a-001', timestamp: 'Apr 18, 2026 · 3:42:17 PM', category: 'ads', action: 'bid_adjustment', entity: 'Dental Implants — All-on-4', detail: "Bid increased +$0.12 on keyword 'dental implants nyc'", before: '$2.45', after: '$2.57', status: 'success', trigger: 'ROI optimization' },
  { id: 'a-002', timestamp: 'Apr 18, 2026 · 3:42:11 PM', category: 'ads', action: 'bid_adjustment', entity: 'Emergency Dental', detail: "Bid decreased −$0.08 on keyword 'emergency dentist nyc'", before: '$3.20', after: '$3.12', status: 'success', trigger: 'CPC efficiency' },
  { id: 'a-003', timestamp: 'Apr 18, 2026 · 3:15:03 PM', category: 'landing', action: 'variant_winner', entity: 'Invisalign LP', detail: 'Variant A declared winner after Validation phase (95% confidence, +22% CR lift)', before: '50/50 split', after: '100% Variant A', status: 'success', trigger: 'Statistical significance reached' },
  { id: 'a-004', timestamp: 'Apr 18, 2026 · 3:14:58 PM', category: 'landing', action: 'traffic_route', entity: 'Invisalign LP', detail: 'Routed 100% traffic to winning variant A', before: '50% A / 50% B', after: '100% A', status: 'success', trigger: 'Winner declared' },
  { id: 'a-005', timestamp: 'Apr 18, 2026 · 3:18:12 PM', category: 'gbp', action: 'review_response', entity: 'Google review by Sarah K.', detail: 'Published AI-generated response to 5-star review', before: '—', after: 'Response live', status: 'success', trigger: 'New review detected' },
  { id: 'a-006', timestamp: 'Apr 18, 2026 · 1:45:23 PM', category: 'gbp', action: 'review_response', entity: 'Google review by David M.', detail: 'Published AI-generated response to 4-star review', before: '—', after: 'Response live', status: 'success', trigger: 'New review detected' },
  { id: 'a-007', timestamp: 'Apr 18, 2026 · 11:30:44 AM', category: 'gbp', action: 'review_response', entity: 'Google review by Patricia L.', detail: 'Published AI-generated response to 4-star review', before: '—', after: 'Response live', status: 'success', trigger: 'New review detected' },
  { id: 'a-008', timestamp: 'Apr 18, 2026 · 10:05:17 AM', category: 'seo', action: 'article_publish', entity: 'Dental Implant Recovery Guide', detail: 'Article published and submitted to sitemap', before: 'Draft', after: 'Published', status: 'success', trigger: 'Content calendar' },
  { id: 'a-009', timestamp: 'Apr 18, 2026 · 10:05:18 AM', category: 'technical', action: 'schema_push', entity: 'Dental Implant Recovery Guide', detail: 'Article schema (BlogPosting, FAQPage) pushed via injector', before: '—', after: 'Schema live', status: 'success', trigger: 'Article published' },
  { id: 'a-010', timestamp: 'Apr 18, 2026 · 9:22:03 AM', category: 'intel', action: 'threat_detect', entity: 'Downtown Dental', detail: 'Detected new competitor offer: free implant consultation', before: '—', after: 'Flagged for monitoring', status: 'success', trigger: 'Daily competitor scan' },
  { id: 'a-011', timestamp: 'Apr 18, 2026 · 6:14:52 AM', category: 'technical', action: 'citation_fix', entity: 'Yelp listing', detail: 'Submitted phone number correction', before: '(212) 555-0101', after: '(212) 555-0100', status: 'success', trigger: 'NAP inconsistency detected' },
  { id: 'a-012', timestamp: 'Apr 18, 2026 · 6:14:28 AM', category: 'technical', action: 'citation_fix', entity: 'Vitals.com listing', detail: 'Submitted address correction', before: 'Missing suite #', after: 'Suite 400 added', status: 'success', trigger: 'NAP inconsistency detected' },
  { id: 'a-013', timestamp: 'Apr 18, 2026 · 6:13:55 AM', category: 'technical', action: 'citation_fix', entity: 'Zocdoc listing', detail: 'Submitted hours correction', before: 'Sat: closed', after: 'Sat: 9am-3pm', status: 'success', trigger: 'NAP inconsistency detected' },
  { id: 'a-014', timestamp: 'Apr 18, 2026 · 6:13:12 AM', category: 'technical', action: 'citation_fix', entity: 'MapQuest listing', detail: 'Submitted phone number correction', before: '(212) 555-0099', after: '(212) 555-0100', status: 'success', trigger: 'NAP inconsistency detected' },
  { id: 'a-015', timestamp: 'Apr 17, 2026 · 4:02:41 PM', category: 'ads', action: 'keyword_pause', entity: 'Emergency Dental', detail: "Paused underperforming keyword 'cheap dentist nyc'", before: 'Active', after: 'Paused', status: 'success', trigger: '30-day ROI threshold not met' },
  { id: 'a-016', timestamp: 'Apr 17, 2026 · 2:30:18 PM', category: 'landing', action: 'variant_gen', entity: 'Weekend Emergency LP', detail: 'Generated 4 variants (urgency, specificity, outcome, control)', before: '1 variant', after: '4 variants ready', status: 'success', trigger: 'Exploration phase starting' },
  { id: 'a-017', timestamp: 'Apr 17, 2026 · 11:15:02 AM', category: 'gbp', action: 'photo_upload', entity: 'Office photos', detail: 'Uploaded 5 new office photos · All auto-categorized', before: '42 photos', after: '47 photos', status: 'success', trigger: 'Photo gap detected' },
  { id: 'a-018', timestamp: 'Apr 17, 2026 · 11:14:32 AM', category: 'gbp', action: 'post_publish', entity: 'GBP Post: New patients welcome', detail: 'Published GBP post', before: 'Draft', after: 'Live on profile', status: 'success', trigger: 'Content calendar' },
  { id: 'a-019', timestamp: 'Apr 17, 2026 · 11:14:05 AM', category: 'gbp', action: 'post_publish', entity: 'GBP Post: $99 whitening special', detail: 'Published GBP post', before: 'Draft', after: 'Live on profile', status: 'success', trigger: 'Promotional campaign active' },
  { id: 'a-020', timestamp: 'Apr 17, 2026 · 10:40:22 AM', category: 'ads', action: 'budget_realloc', entity: 'Dental Implants — All-on-4', detail: 'Reallocated budget across campaigns', before: '$1,000/mo', after: '$1,150/mo', status: 'success', trigger: 'ROI optimization' },
  { id: 'a-021', timestamp: 'Apr 17, 2026 · 10:40:22 AM', category: 'ads', action: 'budget_realloc', entity: 'Cosmetic Veneers — Premium', detail: 'Reallocated budget across campaigns', before: '$400/mo', after: '$250/mo', status: 'success', trigger: 'Competitor CPC pressure' },
  { id: 'a-022', timestamp: 'Apr 17, 2026 · 9:00:14 AM', category: 'seo', action: 'meta_update', entity: '/services/implants', detail: 'Updated meta description for uniqueness and keyword relevance', before: 'Generic 156 chars', after: 'Optimized 159 chars', status: 'success', trigger: 'Duplicate meta detected' },
  { id: 'a-023', timestamp: 'Apr 17, 2026 · 8:22:03 AM', category: 'landing', action: 'variant_retire', entity: 'Weekend Emergency LP', detail: 'Variant C retired — underperforming by 2 SD', before: 'Active', after: 'Retired', status: 'success', trigger: 'Decisive winner shortcut' },
  { id: 'a-024', timestamp: 'Apr 16, 2026 · 2:22:17 PM', category: 'call', action: 'number_assign', entity: 'Pediatric campaign', detail: 'Assigned tracking number from pool', before: '—', after: '(212) 555-0151', status: 'success', trigger: 'Campaign launched' },
  { id: 'a-025', timestamp: 'Apr 16, 2026 · 1:30:05 PM', category: 'landing', action: 'phase_transition', entity: 'Emergency Weekend LP', detail: 'Moved from Exploration to Validation phase', before: 'Exploration', after: 'Validation', status: 'success', trigger: 'Phase 1 budget spent' },
  { id: 'a-026', timestamp: 'Apr 16, 2026 · 8:14:23 AM', category: 'gbp', action: 'post_publish', entity: 'GBP Post: Easter hours', detail: 'Failed to publish — GBP API rate limited', before: 'Draft', after: 'Draft (retry queued)', status: 'retrying', trigger: 'Scheduled post' },
  { id: 'a-027', timestamp: 'Apr 16, 2026 · 6:00:41 AM', category: 'technical', action: 'site_scan', entity: 'smilecentraldental.com', detail: 'Full site scan completed · 8 issues detected', before: 'Score 75', after: 'Score 78', status: 'success', trigger: 'Scheduled every 6 hours' },
  { id: 'a-028', timestamp: 'Apr 15, 2026 · 11:32:08 PM', category: 'intel', action: 'dossier_update', entity: 'Competitor: Manhattan Smiles', detail: 'Weekly dossier refresh — 3 changes detected in offerings', before: '—', after: 'Updated', status: 'success', trigger: 'Scheduled weekly' },
];

export const AL_TOTAL_ACTIONS = AL_SIMPLE_TIMELINE.reduce(
  (sum, day) => sum + day.actionCount,
  0,
);
